/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 岗位列表 的 **请求配置**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/roleList`
 */
const postRoleListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/baobanRoles/roleList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postRoleList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 岗位列表 的 **请求函数**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/roleList`
 */
export const postRoleList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postRoleListRequestConfig, requestData), ...args);
};
postRoleList.requestConfig = postRoleListRequestConfig;
/**
 * 接口 新增岗位 的 **请求配置**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/addRole`
 */
const postAddRoleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/baobanRoles/addRole",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddRole",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新增岗位 的 **请求函数**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/addRole`
 */
export const postAddRole = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postAddRoleRequestConfig, requestData), ...args);
};
postAddRole.requestConfig = postAddRoleRequestConfig;
/**
 * 接口 编辑岗位 的 **请求配置**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/editRoles`
 */
const postEditRolesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/baobanRoles/editRoles",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postEditRoles",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 编辑岗位 的 **请求函数**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/editRoles`
 */
export const postEditRoles = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postEditRolesRequestConfig, requestData), ...args);
};
postEditRoles.requestConfig = postEditRolesRequestConfig;
/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **请求配置**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/getRoles`
 */
const postGetRolesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/baobanRoles/getRoles",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetRoles",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取岗位的权限（编辑岗位时获取） 的 **请求函数**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/baobanRoles/getRoles`
 */
export const postGetRoles = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetRolesRequestConfig, requestData), ...args);
};
postGetRoles.requestConfig = postGetRolesRequestConfig;
/**
 * 接口 获取所有权限 的 **请求配置**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/BaobanRoles/getAllRoles`
 */
const postGetAllRolesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/BaobanRoles/getAllRoles",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetAllRoles",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取所有权限 的 **请求函数**
 *
 * @分类 商家API/商家权限管理
 * @请求头 `POST /erp/BaobanRoles/getAllRoles`
 */
export const postGetAllRoles = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetAllRolesRequestConfig, requestData), ...args);
};
postGetAllRoles.requestConfig = postGetAllRolesRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/baobanRoles.js